import {BASE_LABELS_UK} from "@labels/uk/base/baseLabels";


import {LABELS_REPORTS} from "@containers/reports/readyReports/labels/labels";
import {AUTH_LABELS} from "@containers/auth/labels/labels";
import {LABELS_SCHEDULE_EXECUTION} from "@containers/reports/readyReports/reportScheduleExecution/labels/labels";
import {MAP_LABELS_ROOT} from "@containers/map/containers/navigateMapFeatures/labels/labels";
import {LABELS_DEVICES} from "@containers/device/labels/labels";
import {GEO_GROUPS_LABELS} from "@containers/map/containers/geoGroups/labels/labels";
import {TRACK_ADVANCED_LABELS} from "@containers/map/containers/trackAdvanced/labels/labels";
import {AUTO_TRACKING_LABELS} from "@containers/map/containers/autoTracking/labels/labels";
import {
    LABELS_DEVICE_OPERATIONS_STATISTIC
} from "@containers/device/containers/deviceOperationalStatistic/labels/labels";
import {LABELS_SINGLE_VOYAGE} from "@containers/singleVoyage/labels/labels";
import {LABELS_VOYAGE_PLANNING} from "@containers/voyagePlanning/labels/labels";
import {LABELS_EQUIPMENT} from "@containers/equipment/labels/labels";
import {LABELS_DASHBOARD} from "@containers/dashboard/labels/labels";
import {LABELS_ADMIN_ACCOUNTS} from "@containers/adminAccounts/labels/labels";
import {LABELS_ADMIN_SYSTEM} from "@containers/adminSystem/labels/labels";

export const LABELS_UK = {
    ...BASE_LABELS_UK,
    reportLabels: LABELS_REPORTS,
    devices: LABELS_DEVICES,
    auth: AUTH_LABELS,
    scheduleExecution: LABELS_SCHEDULE_EXECUTION,
    mapLabels: MAP_LABELS_ROOT,
    geoGroups: GEO_GROUPS_LABELS,
    trackAdvanced: TRACK_ADVANCED_LABELS,
    autoTracking: AUTO_TRACKING_LABELS,
    deviceOperationStatistic: LABELS_DEVICE_OPERATIONS_STATISTIC,
    singleVoyage: LABELS_SINGLE_VOYAGE,
    voyagePlanning: LABELS_VOYAGE_PLANNING,
    equipment: LABELS_EQUIPMENT,
    dashboardPage: LABELS_DASHBOARD,
    adminAccounts: LABELS_ADMIN_ACCOUNTS,
    adminSystem: LABELS_ADMIN_SYSTEM,

};
